<template>
  <div class="media">
    <div class="media-left">
      <div class="image is-48x48">
        <img
          v-if="comment.user_role === 'user'"
          :src="comment.user.profile_picture.sm"
          class="is-rounded"
        />
        <img
          v-if="comment.user_role === 'moderator'"
          src="/images/logos/mplus.jpg"
          class="is-rounded"
        />
      </div>
    </div>

    <div class="media-content">
      <div>
        <strong v-if="comment.user_role === 'user'">{{ comment.user.name }}</strong>
        <strong v-if="comment.user_role === 'moderator'">M+ тусламжийн алба</strong>
        <small>{{ comment.formatted_created_at }}</small>
        <span v-if="comment.reviewable">&raquo;</span>
        <a v-if="comment.reviewable">{{ comment.reviewable.title }}</a>
      </div>

      <div v-if="!editing" class="content">{{ comment.comment }}</div>

      <form v-if="editing" @submit.prevent="save">
        <b-field>
          <b-input
            type="textarea"
            placeholder="Сэтгэгдэл бичих ..."
            rows="3"
            v-model="form.comment"
          ></b-input>
        </b-field>

        <div v-if="form.comment.length > 0">
          <button
            class="button is-primary"
            :class="{ 'is-loading': form.processing }"
            :disabled="form.comment === comment.comment"
          >Save</button>

          <button type="button" class="button is-white" @click="cancel">Цуцлах</button>
        </div>
      </form>

      <div class="level is-mobile">
        <div class="level-left">
          <div v-if="canReply" class="level-item">
            <button class="button is-small" @click="replying = !replying">Хариу</button>
          </div>

          <div v-if="!editing && editVisible" class="level-item">
            <b-dropdown>
              <button class="button is-small" slot="trigger">
                <span>Edit</span>
                <b-icon icon="menu-down"></b-icon>
              </button>
              <b-dropdown-item @click="editing = true">Сэтгэгдэл засах</b-dropdown-item>
              <b-dropdown-item @click="destroy">Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>

      <compose v-if="replying" type="review" :id="comment.id" @commented="addReply"></compose>

      <comment
        v-for="reply in replies"
        :key="reply.id"
        :comment="reply"
        @destroyed="removeReply(reply)"
      >
        <div slot="media-right"></div>
      </comment>
    </div>

    <div class="media-right">
      <slot name="media-right">
        <love-button
          type="review"
          :id="comment.id"
          :count="comment.likes_count"
          v-model="comment.status.liked"
          icon="thumb-up"
          color="is-primary"
        ></love-button>
      </slot>
    </div>
  </div>
</template>

<script>
import LoveButton from "./../LoveButton";
import Compose from "./Compose";

export default {
  name: "comment",

  components: {
    LoveButton,
    Compose
  },

  props: {
    comment: {
      type: Object,
      required: true
    },

    canReply: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      replying: false,
      editing: false,
      form: new window.Form({
        comment: this.comment.comment
      }),
      replies: []
    };
  },

  created() {
    this.replies = this.comment.latest_five_replies;
  },

  computed: {
    inAdmin() {
      return window.location.pathname.startsWith("/admin");
    },

    editVisible() {
      return (
        this.$store.getters.signedIn &&
        (this.$store.state.auth.user.id === this.comment.user.id ||
          this.inAdmin)
      );
    }
  },

  methods: {
    destroy() {
      this.form
        .delete("/api/reviews/" + this.comment.id)
        .then(({ message }) => {
          this.$buefy.toast.open(message);
          this.$emit("destroyed");
        });
    },

    cancel() {
      this.form.comment = this.comment.comment;
      this.editing = false;
    },

    save() {
      this.form
        .takeAtLeast(500)
        .put("/api/reviews/" + this.comment.id)
        .then(({ message }) => {
          this.$buefy.toast.open(message);
          this.editing = false;
          this.comment.comment = this.form.comment;
          this.$emit("updated");
        });
    },

    removeReply(reply) {
      let index = this.replies.indexOf(reply);

      this.replies.splice(index, 1);
    },

    addReply(reply) {
      this.replies.push(reply);
    }
  }
};
</script>
